import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { applyTheme, getTheme } from './themes';

// Apply theme IMMEDIATELY based on port
const port = window.location.port;
const themeMap = {
  '3000': 'purple',
  '3010': 'green',
  '3020': 'pink'
};
const themeName = process.env.REACT_APP_THEME || 'green';
console.log('Initial theme:', themeName);
applyTheme(getTheme(themeName));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);